import { cn } from "design-system/utils"
import { MessageCircleQuestion, Sparkles } from "lucide-react"
import { getSupportEntityTimelineRowId } from "modules/support/lib/supportEntityMarker"
import { useTranslation } from "react-i18next"
import { ConversationSupportQuestionItemResponseDataSchema } from "schema"
import { z } from "zod"
import { EntityIconTooltip, EntityRow } from "./EntityRow"

type Props = {
  item: z.infer<typeof ConversationSupportQuestionItemResponseDataSchema>
  isFirst: boolean
  isLast: boolean
  onClick: () => void
}

export function QuestionEntityRow({ item, isFirst, isLast, onClick }: Props) {
  return (
    <EntityRow
      id={getSupportEntityTimelineRowId(item.kind, item.id)}
      bulletClassName="bg-chart-4"
      text={item.summary}
      isFirst={isFirst}
      isLast={isLast}
      onClick={onClick}
      badge={<QuestionStatusIcon item={item} showDefaultIcon />}
    />
  )
}

export function QuestionStatusIcon({
  item,
  className,
  hasTooltip = true,
  showDefaultIcon = false,
}: {
  item: Pick<z.infer<typeof ConversationSupportQuestionItemResponseDataSchema>, "answeredAt">
  className?: string
  hasTooltip?: boolean
  showDefaultIcon?: boolean
}) {
  const { t } = useTranslation()
  const isAnsweredAutomatically = item.answeredAt !== null

  if (isAnsweredAutomatically) {
    const icon = <Sparkles size={14} className={cn("text-chart-4", className)} />

    return hasTooltip ? (
      <EntityIconTooltip label={t("support.entities.status.answeredAutomatically")}>
        {icon}
      </EntityIconTooltip>
    ) : (
      icon
    )
  }

  if (!showDefaultIcon) return null

  return <MessageCircleQuestion size={14} className={cn("text-muted-foreground", className)} />
}
